import iviTemplate from './ivideon.twig';
import Select from 'components/forms/select';
import youtubeTemplate from './youtube.twig';

class CameraView {
    /**
     * @constructor
     */
    constructor() {
        this.target = {};
        this.service = '';
        this.template = {};
        this.container = {};
        this.btns = [];
        this.btnMobile = {};
        this.activeBtn = {};
        this.playBtn = {};
        this.onlineSelect = {};
    }

    /**
     * инициализация
     * @param {Object} options - внешние параметры
     */
    init(options) {
        this._setOptions(options);
        this._bindEvents();

        if (this.btns.length) {
            this.activeBtn = this.btns[0];
            this.activeBtn.classList.add('is-active');
        }

        if (this.onlineSelect) {
            this._initSelect();
        }
    }

    _initSelect() {
        new Select({
            element      : this.onlineSelectSelector,
            disableSearch: true,
            afterChange  : (val) => {
                if (!val) {
                    return;
                }
                const autoCommand = '?autoplay=1';

                this.btnMobile.classList.add('is-active');
                this.preview.remove();
                this.container.innerHTML = this.template({src: val + autoCommand});
            }
        }).init();
    }

    /**
     * установка элементов
     * @param {Object} options - внешние параметры
     * @private
     */
    _setOptions(options) {
        this.target = options.target;
        this.service = this.target.dataset.service;
        this.container = this.target.querySelector('.object-online__video');
        this.preview = this.target.querySelector('.object-online__video-preview');
        this.btns = this.target.querySelectorAll('.object-online__btn-switch');
        this.btnMobile = this.target.querySelector('.object-online__btn-mobile');
        this.playBtn = this.target.querySelector('.object-online__btn-play');
        this.onlineSelectSelector = `.j-online-select-${this.service}`;
        this.onlineSelect = this.target.querySelector(this.onlineSelectSelector);
        this._setTemplate(this.service);
    }

    /**
     * определение шаблона
     * @param {string} service - название сервиса. ivideon или youtube
     * @private
     */
    _setTemplate(service) {
        switch (service) {
            case 'ivideon':
                this.template = (src) => {
                    return iviTemplate(src);
                };
                break;
            case 'youtube':
                this.template = (src) => {
                    return youtubeTemplate(src);
                };
                break;
            default:
                this.template = (src) => {
                    return iviTemplate(src);
                };
        }
    }

    /**
     * добавление слушателей
     * @private
     */
    _bindEvents() {
        this.playBtn.addEventListener('click', () => {
            return this._insertVideo();
        });
        this.btns.forEach((button) => {
            button.addEventListener('click', () => {
                return this._changeView(button);
            });
        });
    }

    /**
     * вставка видео исходя из шаблона
     * @private
     */
    _insertVideo() {
        const autoCommand = '?autoplay=1';

        this.preview.remove();
        this.container.innerHTML = this.template({src: this.activeBtn.dataset.src + autoCommand});
    }

    /**
     * смена видео
     * @param {Object} button - нажатая кнопка
     * @private
     */
    _changeView(button) {
        this.activeBtn = button;
        this.btns.forEach((element) => {
            if (this.activeBtn === element) {
                element.classList.add('is-active');
            } else {
                element.classList.remove('is-active');
            }

            if (this.service === 'ivideon') {
                if (this.activeBtn.dataset.icon) {
                    this.target.querySelector('.object-online__plan').style.display = 'block';
                    this.target.querySelector('.object-online__plan-icon').src = this.activeBtn.dataset.icon;
                } else {
                    this.target.querySelector('.object-online__plan').style.display = 'none';
                }
            }
        });
        this._insertVideo();
    }
}

export default CameraView;
